function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "folder download");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M9,17H3.72A2,2,0,0,0,4,16V5H20V9a.5.5,0,0,0,1,0V4.5a.5.5,0,0,0-.5-.5H19V2.5a.5.5,0,0,0-.5-.5H6V.5A.5.5,0,0,0,5.5,0H.5A.5.5,0,0,0,0,.5V16a2,2,0,0,0,2,2H9a.5.5,0,0,0,0-1ZM1,16V1H5V2.5a.5.5,0,0,0,.5.5H18V4H3.5a.5.5,0,0,0-.5.5V16a1,1,0,0,1-2,0Zm16.5-5A6.5,6.5,0,1,0,24,17.5,6.51,6.51,0,0,0,17.5,11Zm0,12A5.5,5.5,0,1,1,23,17.5,5.51,5.51,0,0,1,17.5,23ZM20,17.69a.51.51,0,0,1,0,.71l-2.19,2.18a.46.46,0,0,1-.16.11.47.47,0,0,1-.38,0,.46.46,0,0,1-.16-.11L15,18.4a.5.5,0,0,1,.71-.71L17,19V14.77a.5.5,0,1,1,1,0V19l1.33-1.33A.51.51,0,0,1,20,17.69Z"
})));

var SvgFolderDownload = function SvgFolderDownload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFolderDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-download.1fe36ffa.svg";
export { ForwardRef as ReactComponent };